import { render, staticRenderFns } from "./TopUpPayment.vue?vue&type=template&id=712f92ad&scoped=true&"
import script from "./TopUpPayment.vue?vue&type=script&lang=js&"
export * from "./TopUpPayment.vue?vue&type=script&lang=js&"
import style0 from "./TopUpPayment.vue?vue&type=style&index=0&id=712f92ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712f92ad",
  null
  
)

export default component.exports